import { ICardListGroupConfig } from '~/client/src/shared/components/CardList'
import { IResourceRecord } from '~/client/src/shared/components/ResourceCardList/types'
import Localization from '~/client/src/shared/localization/LocalizationManager'
import { IResourceFieldProjector } from '~/client/src/shared/resources/projection/types'
import { IHierarchyAccessors } from '~/client/src/shared/utils/hierarchyAccessors'
import { UNASSIGNED_FILTER_VALUE } from '~/client/src/shared/utils/ZoneLevelLocationConstants'

import { hierarchyOptionOrderNesting } from './hierarchyGrouping'

export const buildResourceGroupConfig = ({
  fieldProjector,
  grouping,
  hierarchy,
}: {
  fieldProjector: IResourceFieldProjector
  grouping: string
  hierarchy: IHierarchyAccessors | undefined
}): ICardListGroupConfig<IResourceRecord> => ({
  groupBy: (record: IResourceRecord) => {
    const ids = fieldProjector
      .resolve(record, grouping)
      .groupEntries.map(entry => entry.id)
    return ids.length ? ids : [UNASSIGNED_FILTER_VALUE]
  },
  getGroupLabel: (key: string) =>
    !key || key === UNASSIGNED_FILTER_VALUE
      ? Localization.translator.unassigned
      : hierarchy
        ? hierarchy.getOwnLabel(key)
        : fieldProjector.fromEntryId(grouping, key).label,
  // Hierarchy fields nest along ancestry in the property's option order (like
  // the desktop table); plain fields stay flat.
  ...(hierarchy && hierarchyOptionOrderNesting(hierarchy)),
})
